export default __webpack_public_path__ + "static/media/10.929ac474.jpg";